"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_insurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f28dca5f-35c9-4552-a244-12d7512ba76e",
    x1: 87.21,
    y1: 90.53,
    x2: 108.3,
    y2: 111.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "insurance-hi"), /*#__PURE__*/React.createElement("g", {
    id: "1d0055d2-80c1-43f4-a809-e7342b2fe274",
    "data-name": "insurance-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b025f15c-99be-4ae8-bbe4-be262aa1a3cd",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e8656286-2012-4398-9766-661416d8071e",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0ebc74b3-e8e9-4afd-8f48-817946e4d4dc",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e2220267-f171-4265-8f01-5c3d20b514ec",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2f870282-61c2-4f9c-8cb6-c1151d486de3",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bde9624a-2892-46aa-a9e0-c031a4a5bed5",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7423e235-3cc2-4257-b9e5-53ce2000c797",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f5f38364-5909-4d7e-8c83-08ad2d609d8b",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "11c81599-6ada-4dc2-82c6-523fc172dd22",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "439de340-ed7d-42a2-9296-9906546868c1",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a7a9ec38-dbd3-4e83-93ca-7bc697b6248e",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8ed0a99b-e3f9-40ae-b47e-9841d61a21b8",
    "data-name": "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "8f78a151-c4b1-4b9b-bcdf-d4f92bcdd73e",
    "data-name": "Bounding Box",
    x: 0.25,
    y: 0.25,
    width: 191.5,
    height: 191.5,
    transform: "translate(191.76 0) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.94,146.5a4,4,0,0,1-4-4V82.59a4,4,0,0,1,8,0V142.5A4,4,0,0,1,95.94,146.5Z",
    transform: "translate(-0.24 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.73 120.2 91.84 112.71 91.74 86 99.73 85.5 99.73 120.2",
    opacity: 0.2,
    fill: "url(#f28dca5f-35c9-4552-a244-12d7512ba76e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,139.21V148a4,4,0,0,1-8,0v-8.79",
    transform: "translate(-0.24 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,148v8.13c0,11.59-9.25,20-22,20s-21.76-8.41-21.76-20a4,4,0,0,1,8,0c0,8.29,6.91,12,13.76,12s14-3.75,14-12V148",
    transform: "translate(-0.24 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,174.12c-12.12,0-21-7.77-21.7-18.66a4,4,0,0,0-.07.66c0,11.59,9.15,20,21.76,20s22-8.41,22-20v-2C100,165.71,90.75,174.12,78,174.12Z",
    transform: "translate(-0.24 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.16,93.93l.08,0a4,4,0,0,0,4.49-.75c4.29-4.16,11.51-6.64,19.33-6.64,9.21,0,17.74,3.59,21.24,8.93a4,4,0,0,0,3.35,1.81h.17c.41-8.92,3.33-48.88,23.93-77.81C36.48,28.12,24.81,84,23.16,93.93Z",
    transform: "translate(-0.24 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.51 19.5 95.51 19.5 95.52 19.5 95.51 19.5",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.26,19.5h0c20.56,28.88,23.52,68.75,23.93,77.76a3.94,3.94,0,0,0,4-1.75c3.5-5.34,12-8.93,21.24-8.93,7.82,0,15,2.48,19.33,6.64a4,4,0,0,0,4.14.88C167.35,84.71,155.92,28.18,96.26,19.5Z",
    transform: "translate(-0.24 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.16,93.93l.08,0a4,4,0,0,0,4.49-.75c4.29-4.16,11.51-6.64,19.33-6.64,9.21,0,17.74,3.59,21.24,8.93a4,4,0,0,0,3.35,1.81h.17c.41-8.92,3.33-48.88,23.93-77.81C36.48,28.12,24.81,84,23.16,93.93Z",
    transform: "translate(-0.24 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.26,19.5h0c20.56,28.88,23.52,68.75,23.93,77.76a3.94,3.94,0,0,0,4-1.75c3.5-5.34,12-8.93,21.24-8.93,7.82,0,15,2.48,19.33,6.64a4,4,0,0,0,4.14.88C167.35,84.71,155.92,28.18,96.26,19.5Z",
    transform: "translate(-0.24 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.52,90A75.51,75.51,0,0,0,111.25,22a21.81,21.81,0,0,0-30,0A75.51,75.51,0,0,0,21,90a4,4,0,0,0,2.2,3.88C24.81,84,36.48,28.12,95.75,19.5h0C75.15,48.43,72.22,88.39,71.82,97.31A4,4,0,0,0,75,95.51a16.65,16.65,0,0,1,5.53-5l.5-.29.19-.11c3.8-2.4,8.51-3.52,14.79-3.52h.23a34.61,34.61,0,0,1,8.95,1.14,27.56,27.56,0,0,1,6.29,2.5,17,17,0,0,1,6,5.28,4,4,0,0,0,2.7,1.75c-.42-9-3.37-48.89-23.93-77.76h0c59.66,8.68,71.09,65.21,72.63,74.61.12,0,.24-.08.35-.13A4,4,0,0,0,171.52,90Z",
    transform: "translate(-0.24 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.44,89.21a4,4,0,0,1-2.2,2.77c-.11.05-.23.09-.35.13a4,4,0,0,1-4.14-.88c-4.29-4.16-11.51-6.64-19.33-6.64-9.21,0-17.74,3.59-21.24,8.93a4,4,0,0,1-6.69,0,17,17,0,0,0-6-5.28,27.56,27.56,0,0,0-6.29-2.5,34.61,34.61,0,0,0-8.95-1.14H96c-6.28,0-11,1.12-14.79,3.52l-.19.11-.5.29a16.65,16.65,0,0,0-5.53,5,4,4,0,0,1-3.18,1.8h-.17a4,4,0,0,1-3.35-1.81c-3.5-5.34-12-8.93-21.24-8.93-7.82,0-15,2.48-19.33,6.64a4,4,0,0,1-4.49.75l-.08,0A4,4,0,0,1,21,89.21c0,.28-.06.55-.08.83a4,4,0,0,0,2.2,3.88l.08,0a4,4,0,0,0,4.49-.75c4.29-4.16,11.51-6.64,19.33-6.64,9.21,0,17.74,3.59,21.24,8.93a4,4,0,0,0,3.35,1.81h.17A4,4,0,0,0,75,95.51a16.65,16.65,0,0,1,5.53-5l.5-.29.19-.11c3.8-2.4,8.51-3.52,14.79-3.52h.23a34.61,34.61,0,0,1,8.95,1.14,27.56,27.56,0,0,1,6.29,2.5,17,17,0,0,1,6,5.28,4,4,0,0,0,6.69,0c3.5-5.34,12-8.93,21.24-8.93,7.82,0,15,2.48,19.33,6.64a4,4,0,0,0,4.14.88c.12,0,.24-.08.35-.13A4,4,0,0,0,171.52,90C171.5,89.77,171.46,89.49,171.44,89.21Z",
    transform: "translate(-0.24 0)",
    opacity: 0.06
  })))))))))))))));
}

var _default = ic_insurance;
exports.default = _default;